import relayLogHandler, { requiredFieldLogger } from '@atlassian/jira-relay-log/src/index.tsx';
import { getNetwork } from '@atlassian/jira-relay-network/src/index.tsx';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';

export const getRelayEnvironmentConfig = () =>
	getDefaultRelayEnvironmentConfig({
		network: getNetwork(),
		log: relayLogHandler,
		requiredFieldLogger,
	});
